;(function () {
    
    const featuredSlider = () => {
      $('.featured-section').each(function () {
        const $section = $(this);
        const id = $(this).attr('id');
        // const box = $(this).find('.featured-section')

        const autoplay = $section.data('autoplay')
        const stopAutoplay = $section.data('stop-autoplay')
        const delay = $section.data('delay') * 1000
        const speed = $section.data('speed') * 1000
        const pagination = $(this).find('.swiper-pagination')

        console.log(pagination)


        const effect = $section.data('effect') == "custom" ? "fade": $section.data('effect')
        let autoplayParm;
        if (autoplay) {
            autoplayParm = {
                autoplay: {
                    delay: delay,
                    pauseOnMouseEnter: stopAutoplay,
                    disableOnInteraction: false,
                    waitForTransition: true
                },
            }
        } else {
            autoplayParm = {}
        }
        
        if ($section.hasClass('slider_started')) {
          return;
        }
    
        $section.addClass('slider_started');
    
        const swiperParms = {
          parallax: $section.data('parallax'),
          effect: 'fade',
          // virtualTranslate: effect == "custom",
          watchSlidesProgress: true,
          speed: speed,
          loop: false,
          centeredSlides: false,
          autoHeight: false,
          calculateHeight: false,
          keyboard: true,
          fadeEffect: { 
              crossFade: true 
          },
          pagination:{
            el:pagination[0],
            type: 'bullets',
          },
          ...autoplayParm,
          on: {
              init: function () {
                  //Fix for first slide
                  if ($section.data('effect') == "custom") {
                      const firstSlide = this.slides[0];
                      if (firstSlide.classList.contains('swiper-slide-active')) {
                          firstSlide.classList.add('no-animation');
                      }
                  }
              }
          }
        };
        
        // 初始化 Swiper 实例
        const swiper = new Swiper(`#${id} .featured-image-container.swiper`, swiperParms);
              
        swiper.on('slideChange', function () {

            if ($section.data('effect') == "custom") {
                //Fix for first slide
                const firstSlide = this.slides[0];
                firstSlide.classList.remove('no-animation'); 

                //Fix autoplay for custom effect
                if (this.params.autoplay.waitForTransition == true) {
                    this.params.autoplay.delay = delay + speed; 
                    this.params.autoplay.waitForTransition = false;
                    this.autoplay.stop();
                    this.autoplay.start();
                }
            }
          
            const activeIndex = swiper.realIndex; // 真实 index，忽略 loop 包装的虚拟 slides
            const $dots = $section.find('.featured-dot');
          
            // 移除所有 active
            $dots.removeClass('active');
          
            // 添加当前 dot 的 active
            $dots.eq(activeIndex).addClass('active');
          
        })
        // 绑定 dot 点击事件
        $section.find('.featured-dot').each(function () {
          const $dot = $(this);
          const slideIndex = parseInt($dot.attr('slideto'), 10) - 1; // 因为 forloop.index 是从 1 开始的
    
          $dot.on('click', function () {
            swiper.slideTo(slideIndex);
            $section.find('.featured-dot').removeClass('active');
            $dot.addClass('active');
          });
        });

        
      });
    };
    const backswiper = () =>{
        $('.back-swiper').each(function() {
          const $section = $(this);
          const id = $section.attr('id');
  
          const bkswiperParms = {
            loop:true,
            slidesPerView :1,
            spaceBetween:20,
            speed:5000,//匀速时间
            autoplay: {
                delay: 0,
                stopOnLastSlide: false,
                disableOnInteraction: true,
            },
            breakpoints: { 
              798: { 
                slidesPerView: 1,
                spaceBetween: 10
              },
              1200:{
                slidesPerView :'2',
                spaceBetween:20,
              }
            }
          }
          const bkswiper = new Swiper(`#${id}.back-swiper.swiper`, bkswiperParms);
        });
    };
	document.addEventListener('DOMContentLoaded', function () {
		featuredSlider();
        backswiper();
	
		document.addEventListener('shopify:section:load', function () {
			featuredSlider();
            backswiper();
		})
	})
})()
